import { ChargeEvent } from "@fairfleet/geotab";
import { useGeotabClient } from "@/components/GeotabClientContext";
import { RESULTS_LIMIT_CHARGE_EVENT } from "@/constants/resultsLimits";
import { usePerDeviceQueries } from "@/hooks/usePerDeviceQueries";
import { ResultsCapError } from "@/utilities/error/ResultsCapError";

export const CHARGE_EVENTS_QUERY_KEY = "chargeEvents";

/**
 * Geotab's charging sessions (`ChargeEvent`, MyGeotab's "Ladevorgänge") per electric device for
 * a period, one query per device. `useChargeEventsByDeviceIds` covers the live view's fixed
 * look-back; this one takes the audited period.
 */
export function useChargeEventsForDevices(
  deviceIds: string[],
  fromDate: Date,
  toDate: Date,
  enabled = true,
) {
  const { geotabClient } = useGeotabClient();

  return usePerDeviceQueries<ChargeEvent>({
    queryKey: CHARGE_EVENTS_QUERY_KEY,
    deviceIds,
    fromDate,
    toDate,
    enabled,
    fetchRecords: async (deviceId, signal) => {
      const events = await geotabClient.get(
        "ChargeEvent",
        { deviceSearch: { id: deviceId }, fromDate, toDate },
        RESULTS_LIMIT_CHARGE_EVENT,
        signal,
      );
      // A full page may hide further sessions; a charging record that looks complete must not be.
      if (events.length >= RESULTS_LIMIT_CHARGE_EVENT) {
        throw new ResultsCapError("ChargeEvent", RESULTS_LIMIT_CHARGE_EVENT);
      }
      return events;
    },
  });
}
